import mainnetAddresses from '@arcxgame/contracts/deployments/mainnet/deployed.json'
import playnetAddresses from '@arcxgame/contracts/deployments/playnet/deployed.json'
import rinkebyAddresses from '@arcxgame/contracts/deployments/rinkeby/deployed.json'
import _ from 'lodash'

export interface Deployment {
  name: string
  source: string
  address: string
  txn: string
  network: string
  version: number
  type: string
  group: string
}

export interface IDeploymentParams {
  name?: string
  source?: string
  address?: string
  version?: number
  type?: string
  group?: string
}

export const loadContracts = (
  chainId: number,
  deploymentParams: IDeploymentParams,
  isPlaynet = false,
): Deployment[] => {
  if (!(chainId === 1 || chainId === 4)) {
    throw 'Only mainnet and rinkeby are supported'
  }

  let deployments: any

  if (chainId === 1) {
    if (isPlaynet) {
      deployments = playnetAddresses
    } else {
      deployments = mainnetAddresses
    }
  } else {
    deployments = rinkebyAddresses
  }

  return _.filter(deployments, _.matches(deploymentParams))
}
